export type IViewport = Readonly<{
    width: number;
    height: number;
}>;

export const DEFAULT_VIEWPORT: IViewport = { width: 1440, height: 700 };

export const enum BreakPoint {
    MIN = 0,
    SMALL = 500,
    MEDIUM = 768,
    LARGE = 960,
}
